import React, {Component, lazy, Suspense, useEffect} from 'react';
import {BrowserRouter, Route, Routes, Navigate, useLocation} from 'react-router-dom';
import SnackbarAlert from './components/common/SnackbarAlert';
import { withRouter } from './components/common/common/withRouter';
import AppContext from './context/AppContext';
import SalesPage from './components/SelfServe/SalesPage';
import axios from "axios";
import { useParams } from 'react-router-dom';

const SalesPage2 = lazy(() => import('./components/SelfServe/SalesPage2'));
const paths = require('./paths.json');

// Tracked link redirect: /r/:code → backend /r/:code (logs click, then 302s to checkout)
function TrackedLinkRedirect() {
  const { code } = useParams();
  useEffect(() => {
    if (code) window.location.href = `${paths.BACKEND_URL}r/${code}/`;
  }, [code]);
  return null;
}

// Global interceptor: inject X-Acting-As header into all requests when admin is managing another account
axios.interceptors.request.use((config) => {
    const actingAs = localStorage.getItem('acting_as_creator');
    if (actingAs) {
        config.headers['X-Acting-As'] = actingAs;
    }
    return config;
});

const SalesPageOld = lazy(() => import('./components/SelfServe/SalesPageOld'));
const SwitchPage = lazy(() => import('./components/SelfServe/SwitchPage'));
const StripeRedirect = lazy(() => import('./components/Pages/StripeRedirect'));

const Home = lazy(() => import('./components/Home/Home'));
const UserLogin = lazy(() => import('./components/Login_Register/UserLogin'));
const UserRegister = lazy(() => import('./components/Login_Register/UserRegister'));
const UserRegisterRedirect = lazy(() => import('./components/Login_Register/UserRegisterRedirect'));



const CompleteProfile = lazy(() => import('./components/Login_Register/CompleteProfile'));
// const Content = lazy(() => import('./components/Content/Content'));
const Influencer = lazy(() => import('./components/Influencer/Influencer'));
const Settings = lazy(() => import('./components/Settings_Profile/Settings'));
const VerifyEmail = lazy(() => import("./components/Emails/VerifyEmail"));
const AllTermsConditions = lazy(() => import("./components/legal/AllTermsConditions"));
const CookiePolicy = lazy(() => import("./components/legal/CookiePolicy"));
const PrivacyPolicy = lazy(() => import("./components/legal/PrivacyPolicy"));
const CompleteAuthentication = lazy(() => import('./components/Login_Register/CompleteAuthentication'));
// const LandingPage = lazy(() => import('./components/SelfServe/LandingPage'));
const PricingPage = lazy(() => import('./components/SelfServe/PricingPage'));
const PricingPageOld = lazy(() => import('./components/SelfServe/PricingPageOld'));
const GuideLandingPage = lazy(() => import('./components/SelfServe/GuideLandingPage'));
const CheckoutRedirect = lazy(() => import('./components/Influencer/CheckoutRedirect'));


const ForgotPassword = lazy(() => import("./components/Login_Register/Forgotten_Forms/ForgotPassword"));
const EmailConfirmation = lazy(() => import("./components/Login_Register/Forgotten_Forms/EmailConfirmation"));
const PasswordReset = lazy(() => import("./components/Login_Register/Forgotten_Forms/PasswordReset"));
const PasswordChanged = lazy(() => import("./components/Login_Register/Forgotten_Forms/PasswordChanged"));
const ImagePostType = lazy(() => import("./components/Content/content_upload_type/ImagePostType"));
const VideoPostType = lazy(() => import("./components/Content/content_upload_type/VideoPostType"));
const AudioPostType = lazy(() => import("./components/Content/content_upload_type/AudioPostType"));
const PdfPostType = lazy(() => import("./components/Content/content_upload_type/PdfPostType"));
const TextPostType = lazy(() => import("./components/Content/content_upload_type/TextPostType"));
const LivePostType = lazy(() => import("./components/Content/content_upload_type/LivePostType"));

const EditPost = lazy(() => import("./components/Content/EditPost"));
const Staff = lazy(() => import('./components/Staff/Staff'));
const StaffInfluencerApprovalPortal = lazy(() => import("./components/Staff/StaffInfluencerApprovalPortal"));
const StaffAllAnalytics = lazy(() => import("./components/Staff/StaffAllAnalytics"));
const OptOutEmail = lazy(() => import('./components/Emails/OptOutEmail'));
const AffiliateDashboard = lazy(() => import('./components/Affiliate/AffiliateDashboard'));
const LivePostBroadcast = lazy(() => import("./components/Content/LivePostBroadcast"));
const HomeDiscover = lazy(() => import("./components/Home/HomeDiscover"));
// const CreatorSurvey= lazy(() => import('./components/SelfServe/CreatorSurvey'));
const BugReport = lazy(() => import('./components/SelfServe/BugReport'));
// const UserSurvey = lazy(() => import('./components/Home/UserSurvey'));
const SelfServeMaster = lazy(() => import('./components/SelfServe/OnboardingComponents/SelfServeMaster'));
const QuickSignupMaster = lazy(() => import('./components/SelfServe/NewOnboardingFlow/QuickSignupMaster'));
const EmailLoginRedirect = lazy(() => import('./components/Influencer/EmailLoginRedirect'));
const OpenApp = lazy(() => import('./components/Influencer/OpenApp'));
const StripePricingTable = lazy(() => import('./components/Influencer/StripePricingTable'));
const CreatorPricingModalUpgrade = lazy(() => import('./components/Settings_Profile/Profile/CreatorPricingModalUpgrade'));
// Onboarding



// if (window.location.hostname === "localhost") {
//   axios.interceptors.request.use((config) => {
//     if (
//       config.url.includes("api/influencer/course/upload_sales_file") && 
//       Math.random() < 0.8
//     ) {
//       console.warn("💥 Simulated failure for api/influencer/course/upload_sales_file");
//       return Promise.reject(new Error("Simulated network failure"));
//     }
//     return config;
//   });
// }

// const INTERCOM_APP_ID = 'lfsiny3p';

// Wrapper component for AffiliateDashboard that extracts influencer from URL query params
const AffiliateDashboardWrapper = () => {
   const urlParams = new URLSearchParams(window.location.search);
   const influencer = urlParams.get('influencer');
   return <AffiliateDashboard influencer={influencer} />;
};

const hideShellAfterFirstPaint = () => {
   const hide = () => window.__hideShell && window.__hideShell();
   const root = document.getElementById('root');
   if (!root) return hide();

   const hasVisibleContent = () => {
      // Find any visible element under #root
      const el = root.querySelector('*');
      if (!el) return false;
      const rect = el.getBoundingClientRect();
      const cs = getComputedStyle(el);
      return rect.width > 0 && rect.height > 0 && cs.visibility !== 'hidden';
   };

   const finish = () => {
      if ('requestAnimationFrame' in window) {
         requestAnimationFrame(() => requestAnimationFrame(hide));
      } else {
         setTimeout(hide, 0);
      }
   };

   if (hasVisibleContent()) return finish();

   const mo = new MutationObserver(() => {
      if (hasVisibleContent()) {
         mo.disconnect();
         finish();
      }
   });
   mo.observe(root, { childList: true, subtree: true });
}


class App extends Component {
   static contextType = AppContext

   componentDidMount() {
      // Set dev flag early
      const __DEV__ = window.location.hostname === 'localhost';
      window.__DEV__ = __DEV__;

      hideShellAfterFirstPaint();
    }

   onRouteChanged() {
      // console.log("ROUTE CHANGED");
   }
   componentDidUpdate(prevProps) {
      if (this.props.location !== prevProps.location) {
         this.onRouteChanged();
      }
   }
   componentWillUnmount() {
      if (this._obs) this._obs.disconnect();
      if (this._shellTimer) clearTimeout(this._shellTimer);
    }

   render() {
      const { snackConfig, setSnackConfig } = this.context;
      const hostname = window.location.hostname;
      return (
         <>
            {/* <IntercomProvider appId={INTERCOM_APP_ID} > */}
            {/*<ThemeProvider*/}
            {/*   options={{*/}
            {/*      theme: 'light',*/}
            {/*      save: true,*/}
            {/*   }}*/}
            {/*>*/}
            <Routes>
               {![
                  "localhost",
                  "localhost:3000",
                  "fitwith.io",
                  "withme.so",
                  "with-me.shop",
                  "with-me.store"
               ].includes(hostname.replace(/^www\./, '')) ? 
                  <>
                     <Route sensitive={false} path="/login" element={<Suspense fallback={<></>}><UserLogin /></Suspense>} />
                     <Route sensitive={false} path="/register" element={<Suspense fallback={<></>}><UserRegister /></Suspense>} />
                     <Route sensitive={false} path="/register_redirect" element={<Suspense fallback={<></>}><UserRegisterRedirect /></Suspense>} />
                     <Route sensitive={false} path="/forgot_password" element={<Suspense fallback={<></>}><ForgotPassword /></Suspense>} />
                     <Route sensitive={false} path="/email_confirmation" element={<Suspense fallback={<></>}><EmailConfirmation /></Suspense>} />
                     <Route sensitive={false} path="/password_reset" element={<Suspense fallback={<></>}><PasswordReset /></Suspense>} />
                     <Route sensitive={false} path="/password_changed" element={<Suspense fallback={<></>}><PasswordChanged /></Suspense>} />
                     <Route sensitive={false} path="/terms_and_conditions" element={<Suspense fallback={<></>}><AllTermsConditions /></Suspense>} />
                     <Route sensitive={false} path="/cookie_policy" element={<Suspense fallback={<></>}><CookiePolicy /></Suspense>} />
                     <Route sensitive={false} path="/privacy_policy" element={<Suspense fallback={<></>}><PrivacyPolicy /></Suspense>} />

                     <Route sensitive={false} path="/email_login_redirect" element={<Suspense fallback={<></>}><EmailLoginRedirect /></Suspense>} />
                     <Route sensitive={false} path="/email_login_redirect_app" element={<Suspense fallback={<></>}><EmailLoginRedirect /></Suspense>} />
                     <Route sensitive={false} path="/open_app" element={<Suspense fallback={<></>}><OpenApp /></Suspense>} />
                     <Route sensitive={false} path="/login/complete-profile" element={<Suspense fallback={<></>}><CompleteProfile /></Suspense>} />
                     <Route sensitive={false} path="/stripe_redirect" element={<Suspense fallback={<></>}><StripeRedirect /></Suspense>} />
                     <Route sensitive={false} path="/checkout_redirect" element={<Suspense fallback={<></>}><CheckoutRedirect /></Suspense>} />
                     {/* Affiliate Dashboard Route for custom domains */}
                     <Route sensitive={false} path="/affiliate/dashboard" element={<Suspense fallback={<></>}><AffiliateDashboardWrapper /></Suspense>} />
                  </>
               : 
                  <>
                     <Route sensitive={false} path="/discover" element={<Suspense fallback={<></>}><HomeDiscover /></Suspense>} />
                     <Route sensitive={false} path="/login" element={<Suspense fallback={<></>}><UserLogin /></Suspense>} />
                     <Route sensitive={false} path="/creator_pricing_annual_upgrade" element={<Suspense fallback={<></>}><CreatorPricingModalUpgrade tier={2} coupon={true} /></Suspense>} />
                     <Route sensitive={false} path="/creator_pricing_annual_upgrade1" element={<Suspense fallback={<></>}><CreatorPricingModalUpgrade tier={1} coupon={true} /></Suspense>} />
                     <Route sensitive={false} path="/influencer_pricing_annual_upgrade" element={<Suspense fallback={<></>}><CreatorPricingModalUpgrade tier={2} coupon={false} /></Suspense>} />
                     <Route sensitive={false} path="/influencer_pricing_annual_upgrade1" element={<Suspense fallback={<></>}><CreatorPricingModalUpgrade tier={1} coupon={false} /></Suspense>} />
                     {/* Will rename once everything is ready to go */}
                     {/* <Route path="/login-rebrand" element={<UserLogin/>}/>
                        <Route path="/register-rebrand" element={<UserRegister/>}/> */}
      
                     {/* <Route path="/register_influencer" element={<Register influencer_bool={true}/>}/> */}
                     <Route sensitive={false} path="/register" element={<Suspense fallback={<></>}><UserRegister /></Suspense>} />
                     <Route sensitive={false} path="/register_redirect" element={<Suspense fallback={<></>}><UserRegisterRedirect /></Suspense>} />
                     <Route sensitive={false} path="/checkout_redirect" element={<Suspense fallback={<></>}><CheckoutRedirect /></Suspense>} />
                     <Route sensitive={false} path="/forgot_password" element={<Suspense fallback={<></>}><ForgotPassword /></Suspense>} />
                     <Route sensitive={false} path="/email_confirmation" element={<Suspense fallback={<></>}><EmailConfirmation /></Suspense>} />
                     <Route sensitive={false} path="/password_reset" element={<Suspense fallback={<></>}><PasswordReset /></Suspense>} />
                     <Route sensitive={false} path="/password_changed" element={<Suspense fallback={<></>}><PasswordChanged /></Suspense>} />
                     <Route sensitive={false} path="/terms_and_conditions" element={<Suspense fallback={<></>}><AllTermsConditions /></Suspense>} />
                     <Route sensitive={false} path="/cookie_policy" element={<Suspense fallback={<></>}><CookiePolicy /></Suspense>} />
                     <Route sensitive={false} path="/privacy_policy" element={<Suspense fallback={<></>}><PrivacyPolicy /></Suspense>} />
                     <Route sensitive={false} path="/opt_out" element={<Suspense fallback={<></>}><OptOutEmail /></Suspense>} />
                     <Route sensitive={false} path="/help" element={<Suspense fallback={<></>}><HomeDiscover help_open={true} /></Suspense>} />
                     {/* <Route sensitive={false} path="/help_improve_withme" element={<Suspense fallback={<></>}><CreatorSurvey/></Suspense>}/> */}
                     <Route sensitive={false} path="/report_a_bug" element={<Suspense fallback={<></>}><BugReport /></Suspense>} />
                     {/* <Route sensitive={false} path="/improve_withme" element={<Suspense fallback={<></>}><UserSurvey/></Suspense>}/> */}
                     {/* <Route path="/blog_index" element={<Blog_index/>}/> */}
                     {/* <Route path="/blogs/:blog_id" element={<Blog_post_page/>}/> */}
                     {/*<Route path="/newpost" element={<InfluencerUpload/>}/>*/}
                     {/*<Route path="/influencer_register" element={<InfluencerRegisterStepper/>}>*/}
                     {/*   <Route path=":step" element={<TextMobileStepper/>} />*/}
                     {/*</Route>*/}
      
      
                     {/* Self Serve` */}
                     <Route sensitive={false} path="/become-a-creator" element={<SalesPage />} />
                     <Route sensitive={false} path="/become-a-creator/:refId" element={<SalesPage />} />
                     <Route sensitive={false} path="/become-a-creator2" element={<Suspense fallback={<></>}><SalesPage2 /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator2/:refId" element={<Suspense fallback={<></>}><SalesPage2 /></Suspense>} />
                     <Route sensitive={false} path="/r/:code" element={<TrackedLinkRedirect />} />
                     <Route sensitive={false} path="/become-a-creator-old" element={<Suspense fallback={<></>}><SalesPageOld /></Suspense>} />
                     <Route sensitive={false} path="/switch" element={<Suspense fallback={<></>}><SwitchPage /></Suspense>} />
                     <Route sensitive={false} path="/pricing" element={<Suspense fallback={<></>}><PricingPage /></Suspense>} />
                     <Route sensitive={false} path="/pricing-old" element={<Suspense fallback={<></>}><PricingPageOld /></Suspense>} />
                     <Route sensitive={false} path="/pricing-table" element={<Suspense fallback={<></>}><StripePricingTable /></Suspense>} />
      
                     <Route sensitive={false} path="/building-a-membership-guide" element={<Suspense fallback={<></>}><GuideLandingPage /></Suspense>} />
      
                     {/* <Route sensitive={false} path="/influencer/dashboard" element={<Dashboard/>}/> */}
                     {/* <Route sensitive={false} path="/influencer/dashboard/:content_id" element={<Suspense fallback={<></>}><Influencer dashboard={true}/></Suspense>}/>
                        <Route sensitive={false} path="/influencer/dashboard" element={<Suspense fallback={<></>}><Influencer dashboard={true}/></Suspense>}/> */}
                     {/*<Route path="/become-a-creator/register" element={<InfluencerRegister/>}/>*/}
                     {/* <Route path="/become-a-creator" element={<InfluencerStepper/>} /> */}
                     {/* <Route path="/become-a-creator/register" element={<SelfServe0Register/>} />
                        <Route path="/become-a-creator/welcome" element={<SelfServe1Welcome/>} />
                        <Route path="/become-a-creator/your-experience" element={<SelfServe2Question/>} />
                        // {/* <Route path="/become-a-creator/profile-details" element={<SelfServe3ProfileDetails/>} />
                        <Route path="/become-a-creator/profile-images" element={<SelfServe4ProfileImages/>} />
                        <Route path="/become-a-creator/profile-video" element={<SelfServe5ProfileVideo/>} />
                        <Route path="/become-a-creator/content" element={<SelfServe6ContentQuestion/>} />
                        <Route path="/become-a-creator/create-tiers" element={<SelfServe7Tiers/>} />
                        <Route path="/become-a-creator/lets-add-content" element={<SelfServe8ContentUpload/>} /> */}
                     <Route sensitive={false} path="/become-a-creator/register" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'register'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/setup-hub" element={<Suspense fallback={<></>}><QuickSignupMaster current_page={'setup-hub'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/welcome" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'welcome'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/your-experience" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'your-experience'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/start-free-trial" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'start-free-trial'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/personalise-your-domain" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'personalise-your-domain'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/tell-us-about-yourself" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'tell-us-about-yourself'} /></Suspense>} />
      
                     <Route sensitive={false} path="/become-a-creator/profile-details" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'profile-details'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/profile-images" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'profile-images'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/profile-video" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'profile-video'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/content" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'content'} /></Suspense>} />
                     {/* Todo- when page is added, add Helmet to it for dynamic page titles */}
                     <Route sensitive={false} path="/become-a-creator/create-tiers" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'create-tiers'} /></Suspense>} />
                     <Route sensitive={false} path="/become-a-creator/lets-add-content" element={<Suspense fallback={<></>}><SelfServeMaster current_page={'lets-add-content'} /></Suspense>} />
                     <Route sensitive={false} path="/email_login_redirect" element={<Suspense fallback={<></>}><EmailLoginRedirect /></Suspense>} />
                     <Route sensitive={false} path="/email_login_redirect_app" element={<Suspense fallback={<></>}><EmailLoginRedirect /></Suspense>} />
                     <Route sensitive={false} path="/open_app" element={<Suspense fallback={<></>}><OpenApp /></Suspense>} />
                     {/*<Route path="/become-a-creator/0" element={<Register0/>} />*/}
                     {/*<Route path="/become-a-creator/0" element={<Register0/>} />*/}
                     {/*<Route path="/become-a-creator/0" element={<Register0/>} />*/}
                     {/*<Route path="/become-a-creator/0" element={<Register0/>} />*/}
                     {/*<Route path="/become-a-creator/0" element={<Register0/>} />*/}
      
      
      
      
      
                     {/*<Route path="/become-a-creator" element={<InfluencerRegisterStepper/>}>*/}
                     {/*   <Route path=":step" element={<TextMobileStepper/>} />*/}
                     {/*</Route>*/}
      
      
                     {/* Upload Routes */}
                     <Route sensitive={false} path="/upload" element={<Suspense fallback={<></>}><ImagePostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/image" element={<Suspense fallback={<></>}><ImagePostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/video" element={<Suspense fallback={<></>}><VideoPostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/audio" element={<Suspense fallback={<></>}><AudioPostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/pdf" element={<Suspense fallback={<></>}><PdfPostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/text" element={<Suspense fallback={<></>}><TextPostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/live" element={<Suspense fallback={<></>}><LivePostType /></Suspense>} />
                     <Route sensitive={false} path="/upload/live/:influencer_name/:content_id" element={<Suspense fallback={<></>}><LivePostBroadcast /></Suspense>} />
                     {/* Upload Routes */}
                     {/*<Route path="/content_upload/:upload_type" element={<Content_Upload/>}/>*/}
                     <Route sensitive={false} path="/edit/content/:post_id" element={<Suspense fallback={<></>}><EditPost /></Suspense>} />
                     <Route sensitive={false} path="/login/complete-profile" element={<Suspense fallback={<></>}><CompleteProfile /></Suspense>} />
                     <Route sensitive={false} path="/completing_authentication" element={<Suspense fallback={<></>}><CompleteAuthentication /></Suspense>} />
                     <Route sensitive={false} path="/stripe_redirect" element={<Suspense fallback={<></>}><StripeRedirect /></Suspense>} />
                     <Route sensitive={false} path="/settings" element={<Suspense fallback={<></>}><Settings /></Suspense>} />
                     <Route sensitive={false} path="/verify_email" element={<Suspense fallback={<></>}><VerifyEmail /></Suspense>} />
                     {/* Affiliate Dashboard Route */}
                     <Route sensitive={false} path="/affiliate/dashboard" element={<Suspense fallback={<></>}><AffiliateDashboardWrapper /></Suspense>} />
                     {/* <Route path="/contact" element={<ContactUs/>}/> */}
                     {/* <Route path="/contact_influencer_register" element={<ContactUs reason={'influencer'}/>}/> */}
                     <Route sensitive={false} path="/:influencer_name" element={<Suspense fallback={<></>}><Influencer /></Suspense>} />
                     <Route sensitive={false} path="/:influencer_name/:content_id" element={<Suspense fallback={<></>}><Influencer /></Suspense>} />
      
      
      
      
                     {/* <Route path="/reset_password" element={<ForgottenPassword/>}/> */}
                     {/*<Route path="/contact" element={<ContactUs/>}/>*/}
                     <Route sensitive={false} path="/staff" element={<Suspense fallback={<></>}><Staff /></Suspense>}>
                        <Route sensitive={false} path="influencers/await_approval" element={<Suspense fallback={<></>}><StaffInfluencerApprovalPortal /></Suspense>} />
                        <Route sensitive={false} path="analytics" element={<Suspense fallback={<></>}><StaffAllAnalytics /></Suspense>} />
                     </Route>
                  </>
               }
               {(hostname.replace(/^www\./, '') === "with-me.site") ? 
                  // with-me.site -> thescarybookclub
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='thescarybookclub'
                        /></Suspense>} />
                        <Route sensitive={false} path="/thescarybookclub" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='thescarybookclub'
                        /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "cryptocosmopolitan.com") ?
                  // crypto cosmopolitan -> markgraycoaching
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='markgraycoaching'
                        /></Suspense>} />
                        <Route sensitive={false} path="/markgraycoaching" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='markgraycoaching'
                        /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "joe-warren.com") ?
                  // joe-warren.com -> joewarren
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='joewarren'
                        /></Suspense>} />
                        <Route sensitive={false} path="/joewarren" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='joewarren'
                        /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "selfmadeartistblueprint.com") ?
                  // selfmadeartistblueprint.com -> selfmadeartistblueprint
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='bpmproducedit'
                        /></Suspense>} />
                        <Route sensitive={false} path="/bpmproducedit" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='bpmproducedit'
                        /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "neuroscintilla.com") ?
                  // neuroscintilla.com -> neuroscintilla
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='neuroscintilla'
                        /></Suspense>} />
                        <Route sensitive={false} path="/neuroscintilla" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer
                           influencer_name='neuroscintilla'
                        /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "mindfulwithhelen.com") ?
                  // mindfulwithhelen.com -> HelenBarry
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='HelenBarry' /></Suspense>} />
                        <Route sensitive={false} path="/HelenBarry" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='HelenBarry' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "lawandahaneyfit.com") ?
                  // lawandahaneyfit.com -> lawandahaneyfit
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='lawandahaneyfit' /></Suspense>} />
                        <Route sensitive={false} path="/lawandahaneyfit" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='lawandahaneyfit' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "thewytchshaven.com") ?
                  // thewytchshaven.com -> thewytchshaven
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='thewytchshaven' /></Suspense>} />
                        <Route sensitive={false} path="/thewytchshaven" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='thewytchshaven' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "redefineyou.fit") ?
                  // redefineyou.fit -> AnthonyPunshon
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='AnthonyPunshon' /></Suspense>} />
                        <Route sensitive={false} path="/AnthonyPunshon" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='AnthonyPunshon' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "areyoupraying.store") ?
                  // areyoupraying.store -> areyoupraying
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='areyoupraying' /></Suspense>} />
                        <Route sensitive={false} path="/areyoupraying" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='areyoupraying' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "momentumwellness.club") ?
                  // momentumwellness.club -> MomentumWellness
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='MomentumWellness' /></Suspense>} />
                        <Route sensitive={false} path="/MomentumWellness" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='MomentumWellness' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "soulwizdom.com") ?
                  // soulwizdom.com -> KatherineSkaggs
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='KatherineSkaggs' /></Suspense>} />
                        <Route sensitive={false} path="/KatherineSkaggs" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='KatherineSkaggs' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "globalcohorts.org") ?
                  // globalcohorts.org -> globalleaders
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='globalleaders' /></Suspense>} />
                        <Route sensitive={false} path="/globalleaders" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='globalleaders' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "getwithgibson.com") ?
                  // getwithgibson.com -> GibsonGroupLLC
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='GibsonGroupLLC' /></Suspense>} />
                        <Route sensitive={false} path="/GibsonGroupLLC" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='GibsonGroupLLC' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "fosteringembrace.com") ?
                  // fosteringembrace.com -> FosteringEmbrace
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='FosteringEmbrace' /></Suspense>} />
                        <Route sensitive={false} path="/FosteringEmbrace" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='FosteringEmbrace' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "maximizher.com") ?
                  // maximizher.com -> MaximizHER
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='MaximizHER' /></Suspense>} />
                        <Route sensitive={false} path="/MaximizHER" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='MaximizHER' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "becominghomospiritus.com") ?
                  // becominghomospiritus.com -> DavidGruder
                  <>
                        <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='DavidGruder' /></Suspense>} />
                        <Route sensitive={false} path="/DavidGruder" element={<Navigate to="/" replace />} />
                        <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='DavidGruder' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "timetobloom.us") ?
                  // timetobloom.us -> mytimetobloom
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='mytimetobloom' /></Suspense>} />
                     <Route sensitive={false} path="/mytimetobloom" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='mytimetobloom' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "mediumonthego.com") ?
                  // mediumonthego.com -> talkwithcolleen
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='talkwithcolleen' /></Suspense>} />
                     <Route sensitive={false} path="/talkwithcolleen" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='talkwithcolleen' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "malayaneff.com") ?
                  // malayaneff.com -> malayaneff
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='malayaneff' /></Suspense>} />
                     <Route sensitive={false} path="/malayaneff" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='malayaneff' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "marlenelive.com") ?
                  // marlenelive.com -> happyhealthyliving
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='happyhealthyliving' /></Suspense>} />
                     <Route sensitive={false} path="/happyhealthyliving" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='happyhealthyliving' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "theoptionsdoctor.com") ?
                  // theoptionsdoctor.com -> theoptionsdoctor
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='theoptionsdoctor' /></Suspense>} />
                     <Route sensitive={false} path="/theoptionsdoctor" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='theoptionsdoctor' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "calmskinsociety.com") ?
                  // calmskinsociety.com -> calmskinsociety
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='calmskinsociety' /></Suspense>} />
                     <Route sensitive={false} path="/calmskinsociety" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='calmskinsociety' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "passthebarnow.com") ?
                  // passthebarnow.com -> passthebarnow
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='passthebarnow' /></Suspense>} />
                     <Route sensitive={false} path="/passthebarnow" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='passthebarnow' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "certifiedaicopilot.com") ?
                  // certifiedaicopilot.com -> AICOPILOT
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='AICOPILOT' /></Suspense>} />
                     <Route sensitive={false} path="/AICOPILOT" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='AICOPILOT' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "mychatterton.com") ?
                  // mychatterton.com -> chatterton
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='chatterton' /></Suspense>} />
                     <Route sensitive={false} path="/chatterton" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='chatterton' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "everyoneisaphysician.com") ?
                  // everyoneisaphysician.com -> everyoneisaphysician
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='everyoneisaphysician' /></Suspense>} />
                     <Route sensitive={false} path="/everyoneisaphysician" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='everyoneisaphysician' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "christiannetwork.net") ?
                  // christiannetwork.net -> Thechristiannetwork
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='Thechristiannetwork' /></Suspense>} />
                     <Route sensitive={false} path="/Thechristiannetwork" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='Thechristiannetwork' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "lelitebests.com") ?
                  // lelitebests.com -> Lelitebestforempowerment
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='Lelitebestforempowerment' /></Suspense>} />
                     <Route sensitive={false} path="/Lelitebestforempowerment" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='Lelitebestforempowerment' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "bettereracoaching.com") ?
                  // bettereracoaching.com -> bettereracoaching
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='bettereracoaching' /></Suspense>} />
                     <Route sensitive={false} path="/bettereracoaching" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='bettereracoaching' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "homebuyerscoaching.com") ?
                  // homebuyerscoaching.com -> HBCC
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='HBCC' /></Suspense>} />
                     <Route sensitive={false} path="/HBCC" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='HBCC' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "lightwithlarry.com") ?
                  // lightwithlarry.com -> lightbylarry
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='lightbylarry' /></Suspense>} />
                     <Route sensitive={false} path="/lightbylarry" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='lightbylarry' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "opticalbossacademy.com") ?
                  // opticalbossacademy.com -> Glamour4Eyes
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='Glamour4Eyes' /></Suspense>} />
                     <Route sensitive={false} path="/Glamour4Eyes" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='Glamour4Eyes' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "mylast.love") ?
                  // mylast.love -> nataliekita
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='nataliekita' /></Suspense>} />
                     <Route sensitive={false} path="/nataliekita" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='nataliekita' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "quynn.com") ?
                  // quynn.com -> quynnredmountain
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='quynnredmountain' /></Suspense>} />
                     <Route sensitive={false} path="/quynnredmountain" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='quynnredmountain' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "homewardbound.today") ?
                  // homewardbound.today -> HomewardBound
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='HomewardBound' /></Suspense>} />
                     <Route sensitive={false} path="/HomewardBound" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='HomewardBound' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "beautifullifecoaches.com") ?
                  // beautifullifecoaches.com -> 5DMagick
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='5DMagick' /></Suspense>} />
                     <Route sensitive={false} path="/5DMagick" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='5DMagick' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "somaticoperatingsystem.online") ?
                  // somaticoperatingsystem.online -> gregoryjaszewski
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='gregoryjaszewski' /></Suspense>} />
                     <Route sensitive={false} path="/gregoryjaszewski" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='gregoryjaszewski' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "thewhoareyou.com") ?
                  // thewhoareyou.com -> thewhoareyou
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='thewhoareyou' /></Suspense>} />
                     <Route sensitive={false} path="/thewhoareyou" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='thewhoareyou' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "lifegiving.online") ?
                  // lifegiving.online -> lifegiving
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='lifegiving' /></Suspense>} />
                     <Route sensitive={false} path="/lifegiving" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='lifegiving' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "polarchefben.com") ?
                  // polarchefben.com -> polarchefben
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='polarchefben' /></Suspense>} />
                     <Route sensitive={false} path="/polarchefben" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='polarchefben' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "chiefrainmaker.co") ?
                  // chiefrainmaker.co -> chiefrainmaker
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='chiefrainmaker' /></Suspense>} />
                     <Route sensitive={false} path="/chiefrainmaker" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='chiefrainmaker' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "openroadenglish.com") ?
                  // openroadenglish.com -> teachermari
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='teachermari' /></Suspense>} />
                     <Route sensitive={false} path="/teachermari" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='teachermari' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "becomingsacred.me") ?
                  // becomingsacred.me -> becomingsacred
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='becomingsacred' /></Suspense>} />
                     <Route sensitive={false} path="/becomingsacred" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='becomingsacred' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "mrmckos.com") ?
                  // mrmckos.com -> letsbefrank
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='letsbefrank' /></Suspense>} />
                     <Route sensitive={false} path="/letsbefrank" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='letsbefrank' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "mytenniscoachingacademy.app") ?
                  // mytenniscoachingacademy.app -> Mytenniscoaching
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='Mytenniscoaching' /></Suspense>} />
                     <Route sensitive={false} path="/Mytenniscoaching" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='Mytenniscoaching' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "hindimitsandesh.online") ?
                  // hindimitsandesh.online -> Hindimitsandesh
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='Hindimitsandesh' /></Suspense>} />
                     <Route sensitive={false} path="/Hindimitsandesh" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='Hindimitsandesh' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "theprofessionalblueprint.com") ?
                  // theprofessionalblueprint.com -> theprofessionalblueprint
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='theprofessionalblueprint' /></Suspense>} />
                     <Route sensitive={false} path="/theprofessionalblueprint" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='theprofessionalblueprint' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "toolboks.no") ?
                  // toolboks.no -> olechristian
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='olechristian' /></Suspense>} />
                     <Route sensitive={false} path="/olechristian" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='olechristian' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "kellyraysbutchart.com") ?
                  // kellyraysbutchart.com -> kellyraysbutchart
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='kellyraysbutchart' /></Suspense>} />
                     <Route sensitive={false} path="/kellyraysbutchart" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='kellyraysbutchart' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "echomyst.auction") ?
                  // echomyst.auction -> candee
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='candee' /></Suspense>} />
                     <Route sensitive={false} path="/candee" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='candee' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "marketingjester.de") ?
                  // marketingjester.de -> empirely
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='empirely' /></Suspense>} />
                     <Route sensitive={false} path="/empirely" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='empirely' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "brilliantlybold.com") ?
                  // brilliantlybold.com -> thehighlevellife
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='thehighlevellife' /></Suspense>} />
                     <Route sensitive={false} path="/thehighlevellife" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='thehighlevellife' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "dennisisdigital.com") ?
                  // dennisisdigital.com -> dennisisdigital
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='dennisisdigital' /></Suspense>} />
                     <Route sensitive={false} path="/dennisisdigital" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='dennisisdigital' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "elmagoclub.com") ?
                  // elmagoclub.com -> elmagoclub
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='elmagoclub' /></Suspense>} />
                     <Route sensitive={false} path="/elmagoclub" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='elmagoclub' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "wealth-investors.com") ?
                  // wealth-investors.com -> DJtheWealthInvestor
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='DJtheWealthInvestor' /></Suspense>} />
                     <Route sensitive={false} path="/DJtheWealthInvestor" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='DJtheWealthInvestor' /></Suspense>} />
                  </>
               : (hostname.replace(/^www\./, '') === "legacyxlearning.com") ?
                  // legacyxlearning.com -> partners
                  <>
                     <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Influencer influencer_name='partners' /></Suspense>} />
                     <Route sensitive={false} path="/partners" element={<Navigate to="/" replace />} />
                     <Route sensitive={false} path="/:content_id" element={<Suspense fallback={<></>}><Influencer influencer_name='partners' /></Suspense>} />
                  </>
               :
                  <Route sensitive={false} path="/" element={<Suspense fallback={<></>}><Home /></Suspense>} />
               }
            </Routes>
            {/*</ThemeProvider>*/}
            {/* </IntercomProvider> */}


            <SnackbarAlert
               msg={snackConfig.message}
               open={snackConfig.open}
               severity={snackConfig.severity}
               backgroundColor={snackConfig.bgColor ?? 'var(--brand-color)'}
               autoHide={snackConfig.timeout ?? 4000}
               handleClose={() =>
                  setSnackConfig({ open: false })
               }
            />
         </>
      );
   }
}

export default withRouter(App);